import { Renderer } from '@unseenco/taxi';
import { isDEVMODE, viewStorage } from '../_globals'
import WknSwiper from '../modules/wkn-swiper';
import Marquee from '../animations/marquee';
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper'
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay])

export default class Homepage extends Renderer {
  initialLoad() {
    const onDOMContentLoaded = () => {
      document.removeEventListener('DOMContentLoaded', onDOMContentLoaded)
      this.onEnter()
    }

    document.addEventListener('DOMContentLoaded', onDOMContentLoaded)
  }

  onEnter() {
    this.DOM = {
      homeHeroSlider: viewStorage.current.querySelector('.HomeHeroSlider'),
      swiperProducts : viewStorage.current.querySelector('.block-products__slider .swiper'),
      swiperEngagements : viewStorage.current.querySelector('.engagements__slider .swiper'),
      marqueeImgFull : viewStorage.current.querySelector('.img-full .animated'),
      imgGroup : viewStorage.current.querySelector('.txt-3img__image'),
    }

    this.init()
  }

  init() {
    this.initHeroSlider()
    this.initSwiperProducts()
    this.initSwiperEngagements()
    this.initMarquee()
    this.initImgGroup()
  }

  initHeroSlider() {
    if (!this.DOM.homeHeroSlider) return

    const autoplayDelay = 8000
    this.DOM.homeHeroSliderPagination = this.DOM.homeHeroSlider.querySelector('.swiper-pagination')
    this.DOM.homeHeroSliderPagination.style.setProperty('--autoplay-delay', `${autoplayDelay}ms`)

    this.homeHeroSlider = new Swiper(this.DOM.homeHeroSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: this.DOM.homeHeroSlider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      autoplay: {
        delay: autoplayDelay,
      }
    })
  }

  initSwiperProducts() {
    if (!this.DOM.swiperProducts) return

    this.swiperProducts = new WknSwiper(this.DOM.swiperProducts, { 
      slidesPerView: 'auto',
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
        }
      }
    })
  }

  initSwiperEngagements() {
    if (!this.DOM.swiperEngagements) return

    this.swiperEngagements = new WknSwiper(this.DOM.swiperEngagements, { 
      slidesPerView: 1,
      spaceBetween: 15,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
          allowTouchMove: false,
          touchRatio: 0,
        }
      }
    })
  }

  initMarquee() {
    if (!this.DOM.marqueeImgFull) return

    this.marqueeImgFull = new Marquee(this.DOM.marqueeImgFull)
  }

  initImgGroup() {
    if (!this.DOM.imgGroup) return

    let mm = gsap.matchMedia();

    this.imgGroupST = ScrollTrigger.create({
      trigger: imgGroup,
      top: 'top top',
      onLeaveBack: () => this.imgGroup.pause(0)
    })

    this.imgGroup = gsap.timeline({
      paused: true,
      defaults: { ease: 'power4.out', duration: 1.2 },
      scrollTrigger : {
        trigger: this.DOM.imgGroup,
        start: 'center center+=33%',
        end: 'bottom top',
        onEnter: () => this.imgGroup.invalidate().restart()
      }
    })

    mm.add("(min-width: 768px)", () => {
      this.imgGroup.fromTo(this.DOM.imgGroup.querySelectorAll('.visual__container .visual'), { 
        x : () => window.innerWidth * 0.8, 
        yPercent: (index) => gsap.utils.random(0, 100), 
        rotate: (index) => gsap.utils.random(-20, 20) 
      }, { 
        x: 0, 
        yPercent:0, 
        rotate: (index) => gsap.utils.random(-20, 20), 
        duration: (index) => 1.2 + index * 0.3 
      })
    });
    
    mm.add("(max-width: 767px)", () => {
      this.imgGroup.fromTo(this.DOM.imgGroup.querySelectorAll('.visual__container .visual'), { 
        y : () => window.innerHeight * 0.5 
      }, { 
        y: 0, 
        stagger: 0.1 
      })
    });

  }

  onLeaveCompleted() {
    if (this.social) {
      this.social.destroy()
    }
    
    if (this.swiperProducts) {
      this.swiperProducts.destroy()
    }

    if (this.swiperEngagements) {
      this.swiperEngagements.destroy()
    }
    
    if (this.marqueeImgFull) {
      this.marqueeImgFull.destroy()
    }
    
    if (this.imgGroup) {
      this.imgGroupST.kill()
      this.imgGroup.kill(true)
    }
  }
}
